import { useCallback, useState } from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import {
  Card,
  Dialog,
  DialogTitle,
  Divider,
  Button as MuiButton,
} from "@material-ui/core";
import { ChangeSelectedEventsVehicleForm } from "./ChangeSelectedEventsVehicleForm";
import TruckInMotionOutlineIcon from "../../../../../../common/icons/TruckInMotionOutlineIcon";

interface Props {
  selectedRows: number[];
  currentVehicles?: Array<number | null | undefined>;
  latestEvent?: number;
  shouldRenderReactAdminButton?: boolean;
}

export const ChangeEventsVehicle = ({
  selectedRows,
  currentVehicles,
  latestEvent,
  shouldRenderReactAdminButton = true,
}: Props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const handleFailed = useCallback(() => setDialogOpen(false), []);
  const handleSuccess = useCallback(() => {
    setDialogOpen(false);
    notify(
      "resources.hos-driver-log-view.messages.changeEventsVehicleSuccess",
      {
        type: "success",
      }
    );
    refresh();
  }, [refresh, notify]);

  return (
    <>
      {shouldRenderReactAdminButton ? (
        <Button
          className="master-action"
          label="Change vehicle..."
          onClick={() => setDialogOpen(true)}
        >
          <TruckInMotionOutlineIcon />
        </Button>
      ) : (
        <MuiButton
          color="primary"
          variant="text"
          onClick={() => setDialogOpen(true)}
          startIcon={<TruckInMotionOutlineIcon />}
        >
          Change vehicle
        </MuiButton>
      )}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Change vehicle for {selectedRows.length} event(s)
        </DialogTitle>
        <Divider />
        <Card>
          <ChangeSelectedEventsVehicleForm
            selectedRows={selectedRows}
            currentVehicles={currentVehicles}
            latestEvent={latestEvent}
            onSuccess={handleSuccess}
            onFailed={handleFailed}
          />
        </Card>
      </Dialog>
    </>
  );
};
